import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { RouteEntity } from '@core/router/route.entity';


/**
 * Logo
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-logo',
    templateUrl: './logo.component.html',
    styleUrls: ['./logo.component.scss'],
    imports: [NgClass, RouterLink],
})
export class LogoComponent {
    /**
     * Minimal view flag
     * For footer logo variant
     */
    @Input() public minimal: boolean;
    @Input() public staticLogo: boolean;
    @Input() public altText: string;
    @Input() public additionalLogoImgClass: string = 'logo-img';

    public readonly routeEntity: typeof RouteEntity = RouteEntity;
}
